module.exports = __webpack_public_path__ + "img/items_active.13269279.svg";